module.exports = __webpack_public_path__ + "static/media/place_sections_subscription_missing.fc4c091a.png";